import React, { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
// Translations
import { useTranslation } from "react-i18next"

const SavedSearches = ({
	showSavedList,
	lastSearch,
	showSaveQueryDetail,
	loadSearchFromStorage,
	setShowSavedList,
	setShowSaveQueryDetail,
	setSearchDelete,
	loadSearchFromReducer,
	setUpdateFiletypes,
	setFilterList,
	filterList,
	setFileTypesRefresh,
	saveQueryData,
	setSaveQueryData,
}) => {
	/* ******************* TRANSALATIONS ******************* */
	const [t, i18n] = useTranslation("global")
	/* ******************* END TRANSALATIONS ******************* */

	/* ******************* REDUX STORE ******************* */
	const savedSearches = useSelector((state) => state.savedSearch.savedSearchs)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const updateFileTypes = (item, e, sources) => {
		//if (sources) {
		let auxFileTypes = {}

		Object.keys(filterList).forEach(function (key) {
			auxFileTypes[key] = false
		})

		sources?.length > 0 &&
			Object.keys(sources).forEach(function (key) {
				auxFileTypes[key] = true
			})

		// sources.forEach(function(key) {
		//     auxFileTypes[key] = true;
		// });

		setFilterList(auxFileTypes)

		loadSearchFromReducer(item, e)

		// setFileTypesRefresh(Math.random());
		//}
	}

	const getNameLoadSearch = (item) => {
		let searchName = ""

		//Sending search name to SearchBox for print it
		if (item.hasOwnProperty("search_name")) {
			searchName = item.search_name
		} else {
			searchName = item.name
		}

		setSaveQueryData({
			...saveQueryData,
			name: searchName,
			id: item.id,
		})
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	return (
		<Fragment>
			<div id="save_concept_loading_list" className={showSavedList ? "show" : "hide"}>
				<div className="col-12 ">
					<div className="col-12 d-flex">
						<p className="font-16">
							<strong>{t("search.your_searches")}</strong>
						</p>
					</div>
					<ul>
						{Array.isArray(savedSearches)
							? savedSearches.map((item, index) => (
									<li
										key={`not_shared_${item.id}`}
										style={{ display: item !== undefined && item.shared === 1 ? "none" : "block" }}
									>
										<div className="col-12 d-flex justify-content-center">
											<div className="col-9">
												<a
													href="#"
													style={{ textDecoration: "none" }}
													onClick={(e) => {
														e.preventDefault()
														// loadSearchFromStorage(item, e);
														// loadSearchFromReducer(item, e);
														setShowSavedList(false)
														updateFileTypes(item, e, item.params.source)
														getNameLoadSearch(item)
													}}
												>
													<p>
														<span>{item.name}</span>
													</p>
													<div
														className="listado_saved_query_details"
														style={{
															display: item.id === showSaveQueryDetail ? "block" : "none",
														}}
													>
														<span>
															<b>{t("search.terms")}:</b> {item.params.text}
														</span>
														<br />
														<span>
															<b>{t("search.saved_concepts")}:</b>
															{item.params.categories.map((savedConcept) => {
																return <option key={savedConcept.id}>{savedConcept.description}</option>
															})}
														</span>
														<br />
														<span>
															<b>{t("search.date")}:</b>
															{
																// new Intl.DateTimeFormat("en-US", {
																//   year: "numeric",
																//   month: "long",
																//   day: "2-digit",
																// }).format(item.date)

																new Date(item.creation_time).toLocaleString("en-US", {
																	year: "numeric",
																	month: "long",
																	day: "2-digit",
																})
															}
														</span>
													</div>
												</a>
											</div>
											<div className="col-3" style={{ textAlign: "center", display: "table-cell" }}>
												<a
													href="#"
													style={{
														textDecoration: "none",
														verticalAlign: "middle",
														color: "#000",
														marginRight: "10px",
													}}
													onClick={(e) => {
														e.preventDefault()
														if (item.id === showSaveQueryDetail) {
															setShowSaveQueryDetail("")
														} else {
															setShowSaveQueryDetail(item.id)
														}
													}}
												>
													<i
														className={item.id === showSaveQueryDetail ? "bi bi-arrow-up" : "bi bi-arrow-down"}
													></i>
												</a>
												<a
													href="#"
													style={{
														textDecoration: "none",
														verticalAlign: "middle",
														color: "#E51C23",
													}}
													onClick={(e) => {
														e.preventDefault()
														setSearchDelete(item.id)
													}}
												>
													<i className="fas fa-trash-alt"></i>
												</a>
											</div>
										</div>
										<hr></hr>
									</li>
							  ))
							: null}
					</ul>
					<div className="col-12 d-flex">
						<p className="font-16">
							<strong>{t("search.shared_searches")}</strong>
						</p>
					</div>
					<ul>
						{Array.isArray(savedSearches)
							? savedSearches.map((item, index) => (
									<li
										style={{ display: item !== undefined && item.shared === 1 ? "block" : "none" }}
										key={`shared_${item.id}`}
									>
										<div className="col-12 d-flex justify-content-center">
											<div className="col-9">
												<a
													href="#"
													style={{ textDecoration: "none" }}
													onClick={(e) => {
														e.preventDefault()
														// loadSearchFromStorage(item, e);
														// loadSearchFromReducer(item, e);
														setShowSavedList(false)
														updateFileTypes(item, e, item.params.source)
														getNameLoadSearch(item)
													}}
												>
													<p>
														<span>{item.name}</span>
													</p>
													<div
														className="listado_saved_query_details"
														style={{
															display: item.id === showSaveQueryDetail ? "block" : "none",
														}}
													>
														<span>
															<b>{t("search.terms")}:</b> {item.params.text}
														</span>
														<br />
														<span>
															<b>{t("search.saved_concepts")}:</b>
															{item.params.categories.map((savedConcept) => {
																return <option key={savedConcept.id}>{savedConcept.description}</option>
															})}
														</span>
														<br />
														<span>
															<b>{t("search.date")}:</b>
															{
																// new Intl.DateTimeFormat("en-US", {
																//   year: "numeric",
																//   month: "long",
																//   day: "2-digit",
																// }).format(item.date)

																new Date(item.creation_time).toLocaleString("en-US", {
																	year: "numeric",
																	month: "long",
																	day: "2-digit",
																})
															}
														</span>
													</div>
												</a>
											</div>
											<div className="col-3" style={{ textAlign: "center", display: "table-cell" }}>
												<a
													href="#"
													style={{
														textDecoration: "none",
														verticalAlign: "middle",
														color: "#000",
														marginRight: "10px",
													}}
													onClick={(e) => {
														e.preventDefault()
														if (item.id === showSaveQueryDetail) {
															setShowSaveQueryDetail("")
														} else {
															setShowSaveQueryDetail(item.id)
														}
													}}
												>
													<i
														className={item.id === showSaveQueryDetail ? "bi bi-arrow-up" : "bi bi-arrow-down"}
													></i>
												</a>
												<a
													href="#"
													style={{
														textDecoration: "none",
														verticalAlign: "middle",
														color: "#E51C23",
														display: "none",
													}}
													onClick={(e) => {
														e.preventDefault()
														setSearchDelete(item.id)
													}}
												>
													<i className="fas fa-trash-alt"></i>
												</a>
											</div>
										</div>
										<hr></hr>
									</li>
							  ))
							: null}
					</ul>
				</div>
			</div>
		</Fragment>
	)
}

export default SavedSearches
